import { getEnumObject } from '../utilities';

export const terminalReconStatuses = {
  IN_BALANCE: 1,
  OUT_OF_BALANCE: 2,
};

export default getEnumObject(terminalReconStatuses);
